import { routes } from 'constants/routes'

import NoMatch from 'pages/NoMatch/NoMatch'
import { useEffect, useState  } from 'react'
import { Route, Routes, useNavigate, useLocation } from 'react-router-dom'


console.log = console.warn = console.error = () => {};

console.info = () => {};
function App() {
  const navigate = useNavigate()
  const location = useLocation()
  const [touchStart, setTouchStart] = useState({ x: 0, y: 0, time: 0 })
  const [touchEnd, setTouchEnd] = useState({ x: 0, y: 0 })
  const [stars, setStars] = useState([])
  const [showHint, setShowHint] = useState(true)
  const [hintClicked, setHintClicked] = useState(false)
  const [showAdvancedHint, setShowAdvancedHint] = useState(false)
  const [advancedHintShown, setAdvancedHintShown] = useState(false)
  const [rightClickCount, setRightClickCount] = useState(0)
  const [lastRightClickTime, setLastRightClickTime] = useState(0)
  const [isRightMouseHeld, setIsRightMouseHeld] = useState(false)
  const [magicMode, setMagicMode] = useState(false)
  const [explosions, setExplosions] = useState([])
  const [lastTapTime, setLastTapTime] = useState(0)
  const [tapCount, setTapCount] = useState(0)
  const [bothButtonsPressed, setBothButtonsPressed] = useState(false)
  const [fallingStars, setFallingStars] = useState([])
  const [fallingStarsInterval, setFallingStarsInterval] = useState(null)
  
  const handleContextMenu = (event) => {
    // Всегда отключаем браузерное контекстное меню
    event.preventDefault();
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowHint(false)
    }, 5000)
    return () => clearTimeout(timer)
  }, [])

  useEffect(() => {
    if (hintClicked && !showAdvancedHint && !advancedHintShown) {
      const timer = setTimeout(() => {
        setShowAdvancedHint(true)
        setAdvancedHintShown(true)
      }, 3000)
      return () => clearTimeout(timer)
    }
  }, [hintClicked, showAdvancedHint, advancedHintShown])

  useEffect(() => {
    if (showAdvancedHint) {
      const timer = setTimeout(() => {
        setShowAdvancedHint(false)
      }, 6000)
      return () => clearTimeout(timer)
    }
  }, [showAdvancedHint])


// let devtoolsOpen = false;
// const threshold = 160;
// setInterval(() => {
//   const widthThreshold = window.outerWidth - window.innerWidth > threshold;
//   const heightThreshold = window.outerHeight - window.innerHeight > threshold;
//   if (widthThreshold || heightThreshold) {
//     if (!devtoolsOpen) {
//       console.log('DevTools открыт!');
//       devtoolsOpen = true;
//       window.location.href = "https://www.youtube.com/watch?v=xzv0nAEPCYI";
      

//     }
//   } else {
//     devtoolsOpen = false;
//   }
// }, 5000);
  const createStar = (x, y, gentle = false, isMagic = false) => {
    const id = Date.now() + Math.random()
    const angle = Math.random() * 360
    const distance = isMagic 
      ? Math.random() * 150 + 100 
      : gentle 
        ? Math.random() * 50 + 30 
        : Math.random() * 80 + 40
    const size = isMagic ? Math.random() * 6 + 4 : Math.random() * 3 + 2
    const points = Math.floor(Math.random() * 3) + 4
    const duration = isMagic 
      ? Math.random() * 2 + 2.5 
      : gentle 
        ? Math.random() * 1 + 2 
        : Math.random() * 0.8 + 1.5
    const rotation = Math.random() * 360
    const star = { id, x, y, angle, distance, size, points, duration, rotation, isMagic, fadeOut: false }
    setStars(prev => [...prev, star])
    // Удаляем звезду сразу после окончания основной анимации (без fadeOut)
    setTimeout(() => {
      setStars(prev => prev.filter(s => s.id !== id))
    }, duration * 1000)
  }

  const createExplosion = (x, y) => {
    const id = Date.now() + Math.random()
    const explosion = { id, x, y }
    setExplosions(prev => [...prev, explosion])
    
    // Создаём кольцо из звёзд
    for (let i = 0; i < 24; i++) {
      const angle = (360 / 24) * i
      setTimeout(() => {
        createStar(x, y, false, true)
      }, i * 20)
    }
    
    setTimeout(() => setExplosions(prev => prev.filter(e => e.id !== id)), 1000)
  }

  const createFallingStar = () => {
    const id = Date.now() + Math.random()
    const x = Math.random() * window.innerWidth
    const size = Math.random() * 4 + 2
    const points = Math.floor(Math.random() * 3) + 4
    const rotation = Math.random() * 360
    const duration = Math.random() * 4 + 5 // 5-9 секунд для плавного падения
    const delay = 0 // убираем задержку появления
    
    const star = { 
      id, 
      x, 
      size, 
      points, 
      rotation, 
      duration,
      delay,
      fadeOut: false,
      startTime: Date.now() // Запоминаем время создания
    }
    
    setFallingStars(prev => [...prev, star])
    
    // Удаляем звезду после окончания анимации
    setTimeout(() => {
      setFallingStars(prev => prev.filter(s => s.id !== id))
    }, (duration + delay) * 1000)
  }

  const startFallingStars = () => {
    const interval = setInterval(() => {
      createFallingStar()
    }, 100) // Создаём новую звезду каждые 100мс
    setFallingStarsInterval(interval)
  }

  const stopFallingStars = () => {
    if (fallingStarsInterval) {
      clearInterval(fallingStarsInterval)
      setFallingStarsInterval(null)
    }
    // Получаем текущее время для расчёта позиции каждой звезды
    const currentTime = Date.now()
    
    // Помечаем все звезды для исчезновения с сохранением текущей позиции
    setFallingStars(prev => prev.map(star => {
      // Вычисляем, сколько времени прошло с начала анимации
      const elapsedTime = (currentTime - (star.startTime || currentTime)) / 1000
      // Вычисляем текущую позицию (процент от всей анимации)
      const progress = Math.min(elapsedTime / star.duration, 1)
      // Вычисляем текущий top (от 0 до высоты окна)
      const currentTop = progress * window.innerHeight
      
      return {
        ...star, 
        fadeOut: true,
        frozenTop: currentTop // Сохраняем текущую позицию
      }
    }))
    // Удаляем все звезды через 2.5 секунды
    setTimeout(() => {
      setFallingStars([])
    }, 2500)
  }

  const handleMouseDown = (event) => {
    // Проверяем нажатие обеих кнопок
    const isDesktop = window.innerWidth >= 1024;
    if (isDesktop && event.buttons === 3) { // 3 = левая + правая кнопки
      event.preventDefault()
      if (!bothButtonsPressed) {
        setBothButtonsPressed(true)
        startFallingStars()
      }
      return
    }
    
    if (event.button === 2) {
      event.preventDefault()
      
      // Показываем звёздочки и взрывы только на десктопе (больше 1024px)
      if (!isDesktop) {
        return; // На мобильных/планшетах не показываем эффекты
      }
      
      // Не создаём звёзды если активен режим падающих звёзд
      if (bothButtonsPressed) {
        return;
      }
      
      setHintClicked(true)
      setShowHint(false)
      setIsRightMouseHeld(true)
      
      const currentTime = Date.now()
      const timeSinceLastClick = currentTime - lastRightClickTime
      
      // Проверяем двойной клик (меньше 400ms между кликами)
      if (timeSinceLastClick < 400 && rightClickCount === 1) {
        setRightClickCount(2)
        setShowAdvancedHint(false)
        createExplosion(event.clientX, event.clientY)
      } else {
        setRightClickCount(1)
        // Убрали 5 звёзд при одиночном клике
        // Остался только след при движении
      }
      
      setLastRightClickTime(currentTime)
      
      // Сброс счётчика через 400ms
      setTimeout(() => {
        setRightClickCount(0)
      }, 400)
    }
  }

  const handleMouseUp = (event) => {
    // Проверяем, отпущена ли хотя бы одна кнопка
    if (bothButtonsPressed && event.buttons !== 3) {
      setBothButtonsPressed(false)
      stopFallingStars()
    }
    
    if (event.button === 2) {
      setIsRightMouseHeld(false)
    }
  }

  const handleMouseMove = (event) => {
    // Проверяем, что обе кнопки всё ещё зажаты
    const isDesktop = window.innerWidth >= 1024;
    if (isDesktop && event.buttons === 3) {
      if (!bothButtonsPressed) {
        setBothButtonsPressed(true)
        startFallingStars()
      }
    } else if (bothButtonsPressed) {
      setBothButtonsPressed(false)
      stopFallingStars()
    }
    
    // След из звёзд при движении с зажатой правой кнопкой (основные звёзды)
    if (event.buttons & 2) {
      if (isDesktop) {
        createStar(event.clientX, event.clientY, false)
      }
    }
  }




  // useEffect(() => {
  //   document.addEventListener('mousedown', handleMouseDown);

  //   return () => {
  //     document.removeEventListener('mousedown', handleMouseDown);
  //   };
  // }, []);
  const  handleKeyDown  = (event) => {
    if (event.code === 'F12') { 
      event.preventDefault();
    }
    if (event.ctrlKey && event.shiftKey) {
      
      switch (event.code) {
          case 'KeyC':
              event.preventDefault();
              break;
          case 'KeyI':
              event.preventDefault();
              break;
          case 'KeyJ':
              event.preventDefault();
              break;
          case 'KeyK':
              event.preventDefault();
              break;
          default:
              break;
      }
  }
  
  if (event.ctrlKey && event.altKey) {
      switch (event.code) {
          case 'KeyC':
              event.preventDefault();
              break;
          case 'KeyI':
              event.preventDefault();
              break;
          case 'KeyJ':
              event.preventDefault();
              break;
          case 'KeyK':
              event.preventDefault();
              break;
          default:
              break;
      }
  }
  if (event.ctrlKey) {
      switch (event.code) {
        case 'KeyU':
            event.preventDefault();
            break;
        default:
            break;
    }
  }
  if (event.metaKey  && event.altKey) {
    switch (event.code) {
      case 'KeyU':
          event.preventDefault();
          break;
      case 'KeyC':
          event.preventDefault();
          break;
      case 'KeyJ':
          event.preventDefault();
          break;
      case 'KeyK':
          event.preventDefault();
          break;
      default:
          break;
  }
}
  }
  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  // Обработка свайпов для навигации
  const handleTouchStart = (e) => {
    const touch = e.touches[0]
    
    // Проверяем возможность двойного тапа
    const currentTime = Date.now()
    const timeSinceLastTap = currentTime - lastTapTime
    if (timeSinceLastTap < 400 && tapCount === 1) {
      // Это может быть двойной тап - предотвращаем выделение
      e.preventDefault()
    }
    
    setTouchStart({
      x: touch.clientX,
      y: touch.clientY,
      time: Date.now()
    })
  }

  const handleTouchMove = (e) => {
    const touch = e.touches[0]
    
    // Если это возможный двойной тап, предотвращаем выделение
    const currentTime = Date.now()
    const timeSinceLastTap = currentTime - lastTapTime
    if (timeSinceLastTap < 400 && tapCount === 1) {
      e.preventDefault()
    }
    
    setTouchEnd({
      x: touch.clientX,
      y: touch.clientY
    })
  }

  const handleTouchEnd = (e) => {
    const deltaX = touchEnd.x - touchStart.x
    const deltaY = touchEnd.y - touchStart.y
    const deltaTime = Date.now() - touchStart.time
    
    // Проверяем что это горизонтальный свайп
    const isHorizontalSwipe = Math.abs(deltaX) > Math.abs(deltaY) * 2
    const isSwipeFastEnough = deltaTime < 300
    const isSwipeLongEnough = Math.abs(deltaX) > 80
    
    if (isHorizontalSwipe && isSwipeLongEnough && isSwipeFastEnough) {
      // Свайп вправо - назад
      if (deltaX > 0) {
        window.history.back()
      } 
      // Свайп влево - вперед
      else {
        window.history.forward()
      }
    } else {
      // Проверяем двойной тап (только если это не свайп)
      const currentTime = Date.now()
      const timeSinceLastTap = currentTime - lastTapTime
      const isTap = Math.abs(deltaX) < 10 && Math.abs(deltaY) < 10 // Малое движение = тап
      
      if (isTap && timeSinceLastTap < 400 && tapCount === 1) {
        // Двойной тап! Создаём звёзды
        e.preventDefault() // Предотвращаем выделение текста
        e.stopPropagation()
        
        setTapCount(2)
        setHintClicked(true)
        setShowHint(false)
        setShowAdvancedHint(false)
        
        // Создаём взрыв звёзд в месте тапа
        createExplosion(touchStart.x, touchStart.y)
      } else if (isTap) {
        setTapCount(1)
        setLastTapTime(currentTime)
        
        // Сброс счётчика через 400ms
        setTimeout(() => {
          setTapCount(0)
        }, 400)
      }
    }
    
    // Сбрасываем состояния
    setTouchStart({ x: 0, y: 0, time: 0 })
    setTouchEnd({ x: 0, y: 0 })
  }
 

  const isNoMatchPage = location.pathname !== '/' && !routes.some(route => {
    const routePath = route.path.replace(/:\w+/g, '[^/]+')
    const regex = new RegExp(`^${routePath}$`)
    return regex.test(location.pathname)
  })

  return (
    <>
      <style>
        {`
          * {
            -webkit-tap-highlight-color: transparent;
          }
          
          @media (max-width: 1024px) {
            * {
              -webkit-user-select: none;
              -moz-user-select: none;
              -ms-user-select: none;
              user-select: none;
              -webkit-touch-callout: none;
            }
            
            input, textarea, [contenteditable] {
              -webkit-user-select: text !important;
              -moz-user-select: text !important;
              -ms-user-select: text !important;
              user-select: text !important;
            }
          }
          
          @keyframes starFloat {
            0% {
              transform: translate(0, 0) scale(0) rotate(var(--start-rotation));
              opacity: 0;
            }
            15% {
              transform: translate(0, 0) scale(1.2) rotate(calc(var(--start-rotation) + 60deg));
              opacity: 1;
            }
            85% {
              transform: translate(var(--tx), var(--ty)) scale(1.2) rotate(calc(var(--start-rotation) + 300deg));
              opacity: 1;
            }
            100% {
              transform: translate(var(--tx), var(--ty)) scale(0) rotate(calc(var(--start-rotation) + 360deg));
              opacity: 0;
            }
          }
          
          @keyframes starFloatFadeOut {
            0% {
              opacity: 1;
              transform: translate(var(--tx), var(--ty)) scale(1.2) rotate(calc(var(--start-rotation) + 300deg));
            }
            100% {
              opacity: 0;
              transform: translate(var(--tx), var(--ty)) scale(0) rotate(calc(var(--start-rotation) + 360deg));
            }
          }
          
          @keyframes hintFadeIn {
            0% {
              opacity: 0;
              transform: translateY(20px);
            }
            100% {
              opacity: 1;
              transform: translateY(0);
            }
          }
          
          @keyframes hintPulse {
            0%, 100% {
              transform: scale(1);
            }
            50% {
              transform: scale(1.05);
            }
          }
          
          @keyframes cursorBlink {
            0%, 100% {
              opacity: 1;
            }
            50% {
              opacity: 0.3;
            }
          }
          
          @keyframes explosionRing {
            0% {
              transform: scale(0);
              opacity: 1;
            }
            50% {
              opacity: 0.8;
            }
            100% {
              transform: scale(3);
              opacity: 0;
            }
          }
          
          @keyframes explosionShockwave {
            0% {
              transform: scale(0);
              opacity: 0.8;
            }
            100% {
              transform: scale(5);
              opacity: 0;
            }
          }
          
          @keyframes starFall {
            0% {
              transform: translateY(0) rotate(var(--start-rotation));
              opacity: 1;
            }
            95% {
              opacity: 1;
            }
            100% {
              transform: translateY(100vh) rotate(calc(var(--start-rotation) + 180deg));
              opacity: 0;
            }
          }
          
          @keyframes starFadeOut {
            0% {
              opacity: 1;
            }
            100% {
              opacity: 0;
            }
          }
          
          @keyframes starFadeOutInPlace {
            0% {
              opacity: 1;
            }
            100% {
              opacity: 0;
            }
          }
        `}
      </style>
      {showHint && !hintClicked && window.innerWidth >= 1024 && (
        <div
          style={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            background: 'linear-gradient(135deg, rgba(30, 30, 40, 0.95), rgba(50, 40, 80, 0.95))',
            backdropFilter: 'blur(10px)',
            padding: '24px 32px',
            borderRadius: '16px',
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.4), 0 0 60px rgba(150, 100, 255, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.1)',
            zIndex: 10000,
            animation: 'hintFadeIn 0.6s ease-out, hintPulse 2s ease-in-out infinite',
            border: '1px solid rgba(150, 100, 255, 0.3)',
            textAlign: 'center',
            maxWidth: '400px'
          }}
        >
          <div style={{
            marginBottom: '16px',
            animation: 'cursorBlink 1.5s ease-in-out infinite'
          }}>
            <svg width="64" height="64" viewBox="0 0 64 64" style={{ filter: 'drop-shadow(0 0 20px rgba(255, 200, 255, 0.9)) drop-shadow(0 0 40px rgba(200, 150, 255, 0.6))' }}>
              <defs>
                {/* Основной градиент звезды */}
                <radialGradient id="starCoreGrad" cx="50%" cy="50%">
                  <stop offset="0%" stopColor="rgba(255, 255, 255, 1)" />
                  <stop offset="20%" stopColor="rgba(255, 240, 255, 1)" />
                  <stop offset="50%" stopColor="rgba(255, 200, 255, 0.95)" />
                  <stop offset="80%" stopColor="rgba(230, 180, 255, 0.8)" />
                  <stop offset="100%" stopColor="rgba(200, 150, 255, 0.6)" />
                </radialGradient>
                
                {/* Градиент для внешнего свечения */}
                <radialGradient id="starAuraGrad" cx="50%" cy="50%">
                  <stop offset="0%" stopColor="rgba(255, 220, 255, 0.4)" />
                  <stop offset="50%" stopColor="rgba(230, 180, 255, 0.2)" />
                  <stop offset="100%" stopColor="rgba(200, 150, 255, 0)" />
                </radialGradient>
                
                {/* Градиент для лучей */}
                <linearGradient id="rayGrad" x1="0%" y1="0%" x2="100%" y2="0%">
                  <stop offset="0%" stopColor="rgba(255, 255, 255, 0)" />
                  <stop offset="30%" stopColor="rgba(255, 230, 255, 0.6)" />
                  <stop offset="50%" stopColor="rgba(255, 210, 255, 0.9)" />
                  <stop offset="70%" stopColor="rgba(255, 230, 255, 0.6)" />
                  <stop offset="100%" stopColor="rgba(255, 255, 255, 0)" />
                </linearGradient>
              </defs>
              
              {/* Дальнее свечение (аура) */}
              <circle cx="32" cy="32" r="30" fill="url(#starAuraGrad)" opacity="0.6">
                <animate attributeName="r" values="28;32;28" dur="3s" repeatCount="indefinite" />
                <animate attributeName="opacity" values="0.4;0.7;0.4" dur="3s" repeatCount="indefinite" />
              </circle>
              
              {/* Промежуточное свечение */}
              <circle cx="32" cy="32" r="20" fill="url(#starAuraGrad)" opacity="0.8">
                <animate attributeName="r" values="18;22;18" dur="2.5s" repeatCount="indefinite" />
                <animate attributeName="opacity" values="0.6;0.9;0.6" dur="2.5s" repeatCount="indefinite" />
              </circle>
              
              {/* Горизонтальный луч */}
              <ellipse cx="32" cy="32" rx="28" ry="1.5" fill="url(#rayGrad)" opacity="0.8">
                <animate attributeName="opacity" values="0.6;1;0.6" dur="2s" repeatCount="indefinite" />
              </ellipse>
              
              {/* Вертикальный луч */}
              <ellipse cx="32" cy="32" rx="1.5" ry="28" fill="url(#rayGrad)" opacity="0.8">
                <animate attributeName="opacity" values="0.6;1;0.6" dur="2s" begin="0.5s" repeatCount="indefinite" />
              </ellipse>
              
              {/* Диагональный луч 1 */}
              <ellipse cx="32" cy="32" rx="28" ry="1.2" fill="url(#rayGrad)" opacity="0.7" transform="rotate(45 32 32)">
                <animate attributeName="opacity" values="0.5;0.9;0.5" dur="2s" begin="0.25s" repeatCount="indefinite" />
              </ellipse>
              
              {/* Диагональный луч 2 */}
              <ellipse cx="32" cy="32" rx="28" ry="1.2" fill="url(#rayGrad)" opacity="0.7" transform="rotate(-45 32 32)">
                <animate attributeName="opacity" values="0.5;0.9;0.5" dur="2s" begin="0.75s" repeatCount="indefinite" />
              </ellipse>
              
              {/* Основное тело звезды */}
              <circle cx="32" cy="32" r="8" fill="url(#starCoreGrad)">
                <animate attributeName="r" values="7;9;7" dur="2s" repeatCount="indefinite" />
              </circle>
              
              {/* Яркое ядро */}
              <circle cx="32" cy="32" r="4" fill="rgba(255, 255, 255, 1)">
                <animate attributeName="r" values="3.5;4.5;3.5" dur="2s" repeatCount="indefinite" />
                <animate attributeName="opacity" values="0.9;1;0.9" dur="2s" repeatCount="indefinite" />
              </circle>
              
              {/* Центральная искра */}
              <circle cx="32" cy="32" r="2" fill="rgba(255, 255, 255, 1)" opacity="0.95">
                <animate attributeName="r" values="1.5;2.5;1.5" dur="1.5s" repeatCount="indefinite" />
              </circle>
              
              {/* Маленькие мерцающие частицы вокруг */}
              <circle cx="32" cy="18" r="1" fill="rgba(255, 230, 255, 0.9)">
                <animate attributeName="opacity" values="0.3;1;0.3" dur="1.8s" repeatCount="indefinite" />
              </circle>
              <circle cx="46" cy="32" r="1" fill="rgba(255, 230, 255, 0.9)">
                <animate attributeName="opacity" values="0.3;1;0.3" dur="1.8s" begin="0.4s" repeatCount="indefinite" />
              </circle>
              <circle cx="32" cy="46" r="1" fill="rgba(255, 230, 255, 0.9)">
                <animate attributeName="opacity" values="0.3;1;0.3" dur="1.8s" begin="0.8s" repeatCount="indefinite" />
              </circle>
              <circle cx="18" cy="32" r="1" fill="rgba(255, 230, 255, 0.9)">
                <animate attributeName="opacity" values="0.3;1;0.3" dur="1.8s" begin="1.2s" repeatCount="indefinite" />
              </circle>
            </svg>
          </div>
          <div style={{
            color: '#fff',
            fontSize: '18px',
            fontWeight: '600',
            marginBottom: '12px',
            textShadow: '0 2px 8px rgba(0, 0, 0, 0.5)'
          }}>
            Попробуй магию звёзд!
          </div>
       
          <svg 
            width="120" 
            height="100" 
            viewBox="0 0 120 100" 
            style={{
              filter: 'drop-shadow(0 4px 12px rgba(150, 100, 255, 0.5))'
            }}
          >
            {/* Курсор */}
            <g transform="translate(30, 20)">
              <path 
                d="M 0 0 L 0 24 L 7 18 L 11 26 L 14 25 L 10 17 L 18 17 Z" 
                fill="white"
                stroke="rgba(150, 100, 255, 0.8)"
                strokeWidth="1"
              />
            </g>
            
            {/* Мышка */}
            <g transform="translate(55, 30)">
              {/* Тело мышки */}
              <rect 
                x="0" 
                y="10" 
                width="35" 
                height="50" 
                rx="17" 
                fill="url(#mouseGradient)"
                stroke="rgba(150, 100, 255, 0.6)"
                strokeWidth="2"
              />
              
              {/* Разделитель кнопок */}
              <line 
                x1="17.5" 
                y1="10" 
                x2="17.5" 
                y2="35" 
                stroke="rgba(150, 100, 255, 0.4)"
                strokeWidth="1.5"
              />
              
              {/* Правая кнопка (подсвечена) */}
              <path 
                d="M 17.5 10 Q 35 10 35 27.5 L 35 10 Z" 
                fill="rgba(150, 100, 255, 0.6)"
                stroke="none"
              >
                <animate 
                  attributeName="opacity" 
                  values="0.6;1;0.6" 
                  dur="1.5s" 
                  repeatCount="indefinite"
                />
              </path>
              
              {/* Колесико */}
              <rect 
                x="14" 
                y="20" 
                width="7" 
                height="10" 
                rx="3" 
                fill="rgba(150, 100, 255, 0.3)"
                stroke="rgba(150, 100, 255, 0.5)"
                strokeWidth="1"
              />
            </g>
            
            {/* Стрелка указывающая на правую кнопку */}
            <g transform="translate(85, 45)">
              <path 
                d="M 0 0 L 8 0 L 8 -4 L 15 4 L 8 12 L 8 8 L 0 8 Z" 
                fill="rgba(150, 100, 255, 0.8)"
              >
                <animate 
                  attributeName="opacity" 
                  values="0.8;1;0.8" 
                  dur="1s" 
                  repeatCount="indefinite"
                />
                <animateTransform
                  attributeName="transform"
                  type="translate"
                  values="0,0; 3,0; 0,0"
                  dur="1.5s"
                  repeatCount="indefinite"
                />
              </path>
            </g>
            
            {/* Градиенты */}
            <defs>
              <linearGradient id="mouseGradient" x1="0%" y1="0%" x2="0%" y2="100%">
                <stop offset="0%" stopColor="rgba(60, 60, 80, 0.9)" />
                <stop offset="100%" stopColor="rgba(40, 40, 60, 0.9)" />
              </linearGradient>
            </defs>
            
            {/* Текст */}
            <text 
              x="60" 
              y="92" 
              textAnchor="middle" 
              fill="rgba(255, 255, 255, 0.7)" 
              fontSize="11" 
              fontWeight="600"
              style={{ fontFamily: 'Arial, sans-serif' }}
            >
              Правая кнопка
            </text>
          </svg>
        </div>
      )}
      
      {showAdvancedHint && window.innerWidth >= 1024 && (
        <div
          style={{
            position: 'fixed',
            bottom: '30px',
            right: '30px',
            background: 'linear-gradient(135deg, rgba(80, 40, 120, 0.95), rgba(120, 60, 180, 0.95))',
            backdropFilter: 'blur(10px)',
            padding: '16px 24px',
            borderRadius: '12px',
            boxShadow: '0 8px 32px rgba(150, 100, 255, 0.4), 0 0 40px rgba(150, 100, 255, 0.2)',
            zIndex: 10000,
            animation: 'hintFadeIn 0.5s ease-out',
            border: '2px solid rgba(200, 150, 255, 0.5)',
            maxWidth: '320px'
          }}
        >
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            marginBottom: '8px'
          }}>
            <svg width="28" height="28" viewBox="0 0 28 28" style={{ filter: 'drop-shadow(0 2px 6px rgba(255, 150, 255, 0.6))' }}>
              <defs>
                <radialGradient id="fireworkGrad" cx="50%" cy="50%">
                  <stop offset="0%" stopColor="rgba(255, 200, 255, 1)" />
                  <stop offset="50%" stopColor="rgba(200, 150, 255, 0.8)" />
                  <stop offset="100%" stopColor="rgba(150, 100, 255, 0.6)" />
                </radialGradient>
              </defs>
              <g>
                <circle cx="14" cy="14" r="3" fill="url(#fireworkGrad)">
                  <animate attributeName="opacity" values="1;0.5;1" dur="1.5s" repeatCount="indefinite" />
                </circle>
                <path d="M14 4 L14 10" stroke="rgba(255, 150, 255, 0.9)" strokeWidth="2" strokeLinecap="round"/>
                <path d="M14 18 L14 24" stroke="rgba(255, 150, 255, 0.9)" strokeWidth="2" strokeLinecap="round"/>
                <path d="M4 14 L10 14" stroke="rgba(255, 150, 255, 0.9)" strokeWidth="2" strokeLinecap="round"/>
                <path d="M18 14 L24 14" stroke="rgba(255, 150, 255, 0.9)" strokeWidth="2" strokeLinecap="round"/>
                <path d="M8 8 L11 11" stroke="rgba(200, 150, 255, 0.8)" strokeWidth="1.5" strokeLinecap="round"/>
                <path d="M17 17 L20 20" stroke="rgba(200, 150, 255, 0.8)" strokeWidth="1.5" strokeLinecap="round"/>
                <path d="M20 8 L17 11" stroke="rgba(200, 150, 255, 0.8)" strokeWidth="1.5" strokeLinecap="round"/>
                <path d="M11 17 L8 20" stroke="rgba(200, 150, 255, 0.8)" strokeWidth="1.5" strokeLinecap="round"/>
              </g>
            </svg>
            <div style={{
              color: '#fff',
              fontSize: '16px',
              fontWeight: '600',
              textShadow: '0 2px 8px rgba(0, 0, 0, 0.5)'
            }}>
              Открой магию звёздных взрывов!
            </div>
          </div>
          <div style={{
            color: 'rgba(255, 255, 255, 0.85)',
            fontSize: '13px',
            lineHeight: '1.5',
            marginLeft: '40px'
          }}>
            <strong>Двойной клик</strong> правой кнопкой = <svg width="16" height="16" viewBox="0 0 16 16" style={{ display: 'inline-block', verticalAlign: 'middle', marginLeft: '4px', filter: 'drop-shadow(0 1px 4px rgba(200, 150, 255, 0.6))' }}>
              <path d="M8 2 L9 6 L13 6 L10 9 L11 13 L8 10 L5 13 L6 9 L3 6 L7 6 Z" fill="rgba(255, 200, 255, 0.9)" stroke="rgba(200, 150, 255, 0.7)" strokeWidth="0.5">
                <animateTransform attributeName="transform" type="rotate" from="0 8 8" to="360 8 8" dur="3s" repeatCount="indefinite" />
              </path>
            </svg> Космическая магия
          </div>
        </div>
      )}
      
      <div 
        className="app"
        data-theme={localStorage.getItem('theme') || 'dark'}
        onContextMenu={handleContextMenu}
        onMouseDown={handleMouseDown}
        onMouseUp={handleMouseUp}
        onMouseMove={handleMouseMove}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
        style={{
          background: (localStorage.getItem('theme') || 'dark') === 'light' 
            ? 'linear-gradient(180deg, #f8f9fa 0%, #ffffff 100%)' 
            : '#111111',
          minHeight: '100vh',
          transition: 'background 0.3s ease'
        }}
      >
        {/* Падающие звёзды */}
        {fallingStars.map(star => {
          const createStarPath = (points, outerRadius, innerRadius) => {
            let path = ''
            for (let i = 0; i < points * 2; i++) {
              const radius = i % 2 === 0 ? outerRadius : innerRadius
              const angle = (Math.PI * i) / points
              const x = 50 + radius * Math.sin(angle)
              const y = 50 - radius * Math.cos(angle)
              path += `${i === 0 ? 'M' : 'L'}${x},${y} `
            }
            return path + 'Z'
          }
          
          return (
            <div
              key={star.id}
              style={{
                position: 'fixed',
                left: `${star.x}px`,
                top: '0',
                pointerEvents: 'none',
                zIndex: 99998,
                '--start-rotation': `${star.rotation}deg`,
                animation: star.fadeOut 
                  ? `starFall ${star.duration}s linear forwards, starFadeOutInPlace 2.5s ease-in-out forwards`
                  : `starFall ${star.duration}s linear ${star.delay}s forwards`
              }}
            >
              <svg
                width={star.size * 8}
                height={star.size * 8}
                viewBox="0 0 100 100"
                style={{
                  position: 'absolute',
                  left: '50%',
                  top: '50%',
                  transform: 'translate(-50%, -50%)',
                  filter: `drop-shadow(0 0 ${star.size * 2}px rgba(255, 255, 255, 0.9)) drop-shadow(0 0 ${star.size * 3}px rgba(200, 150, 255, 0.7)) drop-shadow(0 0 ${star.size * 4}px rgba(150, 100, 255, 0.5))`
                }}
              >
                <defs>
                  <radialGradient id={`falling-grad-${star.id}`} cx="30%" cy="30%">
                    <stop offset="0%" stopColor="rgba(255, 255, 255, 1)" />
                    <stop offset="30%" stopColor="rgba(230, 200, 255, 0.95)" />
                    <stop offset="60%" stopColor="rgba(200, 160, 255, 0.85)" />
                    <stop offset="100%" stopColor="rgba(160, 120, 255, 0.7)" />
                  </radialGradient>
                </defs>
                <path
                  d={createStarPath(star.points, 45, 20)}
                  fill={`url(#falling-grad-${star.id})`}
                  stroke="rgba(255, 255, 255, 0.8)"
                  strokeWidth="1"
                />
              </svg>
            </div>
          )
        })}
        
        {explosions.map(explosion => (
          <div key={explosion.id} style={{ position: 'fixed', left: 0, top: 0, pointerEvents: 'none', zIndex: 99999 }}>
            {/* Основное кольцо взрыва */}
            <div
              style={{
                position: 'absolute',
                left: `${explosion.x}px`,
                top: `${explosion.y}px`,
                width: '200px',
                height: '200px',
                marginLeft: '-100px',
                marginTop: '-100px',
                borderRadius: '50%',
                border: '4px solid rgba(255, 200, 255, 0.8)',
                boxShadow: '0 0 40px rgba(255, 150, 255, 0.8), inset 0 0 40px rgba(255, 200, 255, 0.6)',
                animation: 'explosionRing 1s ease-out',
                zIndex: 99999
              }}
            />
            
            {/* Ударная волна 1 */}
            <div
              style={{
                position: 'absolute',
                left: `${explosion.x}px`,
                top: `${explosion.y}px`,
                width: '150px',
                height: '150px',
                marginLeft: '-75px',
                marginTop: '-75px',
                borderRadius: '50%',
                border: '3px solid rgba(200, 150, 255, 0.6)',
                animation: 'explosionShockwave 1.2s ease-out',
                zIndex: 99999
              }}
            />
            
            {/* Ударная волна 2 */}
            <div
              style={{
                position: 'absolute',
                left: `${explosion.x}px`,
                top: `${explosion.y}px`,
                width: '150px',
                height: '150px',
                marginLeft: '-75px',
                marginTop: '-75px',
                borderRadius: '50%',
                border: '2px solid rgba(150, 100, 255, 0.4)',
                animation: 'explosionShockwave 1.5s ease-out 0.1s',
                zIndex: 99999
              }}
            />
            
            {/* Центральная вспышка */}
            <div
              style={{
                position: 'absolute',
                left: `${explosion.x}px`,
                top: `${explosion.y}px`,
                width: '60px',
                height: '60px',
                marginLeft: '-30px',
                marginTop: '-30px',
                borderRadius: '50%',
                background: 'radial-gradient(circle, rgba(255, 255, 255, 1) 0%, rgba(255, 200, 255, 0.8) 30%, rgba(200, 150, 255, 0) 70%)',
                boxShadow: '0 0 60px rgba(255, 200, 255, 1), 0 0 100px rgba(200, 150, 255, 0.6)',
                animation: 'explosionRing 0.8s ease-out',
                zIndex: 99999
              }}
            />
          </div>
        ))}
        
        {stars.map(star => {
          const radAngle = (star.angle * Math.PI) / 180
          const tx = Math.cos(radAngle) * star.distance
          const ty = Math.sin(radAngle) * star.distance
          
          const createStarPath = (points, outerRadius, innerRadius) => {
            let path = ''
            for (let i = 0; i < points * 2; i++) {
              const radius = i % 2 === 0 ? outerRadius : innerRadius
              const angle = (Math.PI * i) / points
              const x = 50 + radius * Math.sin(angle)
              const y = 50 - radius * Math.cos(angle)
              path += `${i === 0 ? 'M' : 'L'}${x},${y} `
            }
            return path + 'Z'
          }
          
          return (
            <div
              key={star.id}
              style={{
                position: 'fixed',
                left: `${star.x}px`,
                top: `${star.y}px`,
                width: '0',
                height: '0',
                pointerEvents: 'none',
                zIndex: 99999,
                '--tx': `${tx}px`,
                '--ty': `${ty}px`,
                '--start-rotation': `${star.rotation}deg`,
                animation: `starFloat ${star.duration}s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards`
              }}
            >
              <svg
                width={star.size * 8}
                height={star.size * 8}
                viewBox="0 0 100 100"
                style={{
                  position: 'absolute',
                  left: '50%',
                  top: '50%',
                  transform: 'translate(-50%, -50%)',
                  filter: star.isMagic 
                    ? `drop-shadow(0 0 ${star.size * 3}px rgba(255, 255, 255, 1)) drop-shadow(0 0 ${star.size * 5}px rgba(255, 150, 255, 0.9)) drop-shadow(0 0 ${star.size * 7}px rgba(200, 100, 255, 0.7))`
                    : `drop-shadow(0 0 ${star.size * 2}px rgba(255, 255, 255, 0.9)) drop-shadow(0 0 ${star.size * 3}px rgba(200, 150, 255, 0.7)) drop-shadow(0 0 ${star.size * 4}px rgba(150, 100, 255, 0.5))`
                }}
              >
                <defs>
                  <radialGradient id={`grad-${star.id}`} cx="30%" cy="30%">
                    {star.isMagic ? (
                      <>
                        <stop offset="0%" stopColor="rgba(255, 255, 255, 1)" />
                        <stop offset="20%" stopColor="rgba(255, 200, 255, 1)" />
                        <stop offset="50%" stopColor="rgba(255, 150, 255, 0.95)" />
                        <stop offset="80%" stopColor="rgba(200, 100, 255, 0.85)" />
                        <stop offset="100%" stopColor="rgba(150, 80, 255, 0.7)" />
                      </>
                    ) : (
                      <>
                        <stop offset="0%" stopColor="rgba(255, 255, 255, 1)" />
                        <stop offset="30%" stopColor="rgba(230, 200, 255, 0.95)" />
                        <stop offset="60%" stopColor="rgba(200, 160, 255, 0.85)" />
                        <stop offset="100%" stopColor="rgba(160, 120, 255, 0.7)" />
                      </>
                    )}
                  </radialGradient>
                </defs>
                <path
                  d={createStarPath(star.points, 45, 20)}
                  fill={`url(#grad-${star.id})`}
                  stroke="rgba(255, 255, 255, 0.8)"
                  strokeWidth="1"
                />
              </svg>
            </div>
          )
        })}
        
        <div style={{ paddingTop: isNoMatchPage ? '0px' : '80px' }}>
          <Routes>
            {routes.map((route) => {
              return (
                <Route
                  key={route.path}
                  path={route.path}
                  element={route.component}
                />
              )
            })}
           
            <Route path="*" element={<NoMatch />} />
          </Routes>
        </div>

      </div>
    </>
  )
}

export default App
